import React, {useState} from 'react';
import {SwiperSlide} from 'swiper/react';

import RemoteImage from '@/components/Image/RemoteImage';
import GuideVideo from '@/components/Video/GuideVideo/GuideVideo';
import {VIDEO_PLAY_STATES} from '@/consts/video/videoPlayStates';
import {getLocalizedStrings} from '@/services/localization/localizationService';

const AdvancedDiagnosticCleaningContactsSlides = ({carouselData, sectionTitle, currentSlideIndex}) => {
    return carouselData.map((slideData, index) => (
        <SwiperSlide key={index}>
            <SlideComponent
                sectionTitle={sectionTitle}
                slideData={slideData}
                index={index}
                currentSlideIndex={currentSlideIndex}
            />
        </SwiperSlide>
    ));
};

const SlideComponent = ({slideData, index, currentSlideIndex, sectionTitle}) => {
    const localizedStrings = getLocalizedStrings();
    const {title, description, video, thumbnail, imageMedia, videoStartTime, videoStopTime} = slideData;
    const [isVideoVisible, setIsVideoVisible] = useState(!!video);
    const {isVideoPlay} = getVideoControls(index, currentSlideIndex);
    const playState = isVideoPlay ? VIDEO_PLAY_STATES.PLAYING : VIDEO_PLAY_STATES.STOPPED;

    return (
        <div className='flex h-full w-full max-w-[392px] flex-col rounded-xl text-primary ml:max-w-[370px]'>
            {isVideoVisible ? (
                <GuideVideo
                    src={video}
                    thumbnailSrc={thumbnail}
                    playState={playState}
                    content={[{videoStartTime, videoStopTime}]}
                    onError={() => setIsVideoVisible(false)}
                    containerClassName='h-[176px] ml:h-[208px]'
                    className='absolute left-1/2 top-1/2 z-10 w-full -translate-x-1/2 -translate-y-1/2 bg-primary-dark-5'
                    controlsClassName='m-0 right-4 left-[unset] z-20 rtl:left-4 rtl:right-[unset]'
                />
            ) : (
                <RemoteImage className='h-[176px] w-full bg-center object-cover ml:h-[208px]' imageMedia={imageMedia} />
            )}
            <div className='flex h-full flex-col items-center px-4 py-6 text-center'>
                {sectionTitle && <p className='mb-4 text-16 font-bold'>{sectionTitle}</p>}
                <h2 className='mb-2 text-20'>{localizedStrings[title]}</h2>
                <p>
                    <span
                        className='whitespace-pre-line'
                        dangerouslySetInnerHTML={{
                            __html: localizedStrings[description],
                        }}
                    />
                </p>
            </div>
        </div>
    );
};

const getVideoControls = (index, currentSlideIndex) => {
    const isActiveSlide = index === currentSlideIndex;

    return {
        isVideoPlay: isActiveSlide,
    };
};

export default AdvancedDiagnosticCleaningContactsSlides;
